/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";

export const ReceiverEmailColumnFormatter = (cellContent, row, rowIndex) => {
  const { receiverEmail } = row;

  return (
    <>
      <div className="d-flex align-items-center">
        {receiverEmail ? receiverEmail : `-`}
      </div>
      <> </>
    </>
  );
};
